export default __webpack_public_path__ + "static/room-to-read-v2-4257a2232ff44540e7ce56c3a4bfe8e1.jpg";